import { Autocomplete, Box, TextField } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import fetchApi from "../api/fetchApi";
import Dialog from "../components/dialog/Dialog";
import CustomInput from "../components/inputs/cutsomInput";
import SelectFree from "../components/inputs/selectFree";
import useAuth from "../hooks/useAuth";
import Editor from "react-simple-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

type FormCreateEditType =
  | {
      context: "edit";
      car: any;
      show: boolean;
      setShow: any;
    }
  | {
      context: "create";
      car: undefined;
      show: boolean;
      setShow: any;
    };

const FormCreateEditCar = ({
  context,
  car,
  show,
  setShow,
}: FormCreateEditType) => {
  const { handleSubmit, control, reset, register } = useForm();
  const [isSaving, setisSaving] = useState(false);
  const { token } = useAuth();
  const [image, setImage] = useState<any>();
  const [html, setHtml] = useState(car?.description || "");
  const queryClient = useQueryClient();
  const isEditing = context === "edit";

  function onChange(e: any) {
    setHtml(e.target.value);
  }

  const updateCar = async (data: any) => {
    setisSaving(true);
    const formData = new FormData();

    if (isEditing) {
      formData.append("id", Number(car?.id).toString());
    }
    formData.append("nom", data?.nom);
    formData.append("description", html);

    if (image) {
      formData.append("image", image);
    }

    fetchApi(`project${isEditing ? "/update" : ""}`, token)
      .upload(formData)
      .then((e) => {
        if (e.error) {
          toast(e.messages.message);
        } else if (e.title === "TypeError") {
          toast(e.message);
        } else {
          queryClient.invalidateQueries({
            queryKey: ["CarDetails"],
          });
          queryClient.invalidateQueries({
            queryKey: ["Automobile"],
          });
          handleCloseEdit();
          !isEditing && reset();
          toast("Les  détails du  projet ont été modifié", {
            type: "success",
          });
        }
      })
      .catch((err) => toast(err.message, { type: "error" }))
      .finally(() => setisSaving(false));
  };

  const uploadimg = (e: any) => {
    const file = e.target.files[0];
    if (file) {
      console.log(file);
      setImage(e.target.files[0]);
    }
  };

  const handleCloseEdit = () => {
    setShow(false);
  };

  return (
    <Dialog
      title={isEditing ? `Modifier ${car?.nom}` : "Créer un nouveau projet"}
      handleClose={handleCloseEdit}
      open={show}
      confirm={handleSubmit(updateCar)}
      isStoreActivated={false}
      isConfirming={isSaving}
      id={1}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <CustomInput
          control={control}
          id="nom"
          label="Nom"
          name="nom"
          defaultValue={car?.nom || ""}
          disabled={isSaving}
          rules={{
            required: "This field is required",
          }}
          autoFocus
        />
      </Box>

      <Editor
        value={html}
        onChange={onChange}
        defaultValue={car?.description || ""}
        style={{ paddingBottom: 5 }}
      />
      <br />
      <br />
      <input type="file" {...register("file")} onChange={uploadimg} />
    </Dialog>
  );
};

export default FormCreateEditCar;
